var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconScreencast = function SvgIconScreencast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 6.375v-.5h15.25v12.25h-3.5a1 1 0 1 0 0 2h3.75a1.75 1.75 0 0 0 1.75-1.75V5.625a1.75 1.75 0 0 0-1.75-1.75H4.125a1.75 1.75 0 0 0-1.75 1.75v.75a1 1 0 0 0 2 0M3.375 16.625a1 1 0 1 0 0 2 .5.5 0 0 1 .5.5 1 1 0 1 0 2 0 2.5 2.5 0 0 0-2.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.375 13.875a1 1 0 0 1 1-1 6.25 6.25 0 0 1 6.25 6.25 1 1 0 1 1-2 0 4.25 4.25 0 0 0-4.25-4.25 1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 9.125a1 1 0 0 0 0 2 8 8 0 0 1 8 8 1 1 0 1 0 2 0 10 10 0 0 0-10-10"
  }))));
};
export default SvgIconScreencast;